import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["prefix", "useVirtual", "className", "style", "children"];
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { Menu } from '@cainiaofe/cn-ui';
var CascaderMenu = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CascaderMenu, _Component);
  function CascaderMenu() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.saveMenuRef = function (ref) {
      _this.menuEl = ref;
    };
    _this.saveVirtualRef = function (ref) {
      _this.virtualEl = ref;
    };
    return _this;
  }
  var _proto = CascaderMenu.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.scrollToSelectedItem();
  };
  _proto.scrollToSelectedItem = function scrollToSelectedItem() {
    var _this$props = this.props,
      prefix = _this$props.prefix,
      useVirtual = _this$props.useVirtual,
      children = _this$props.children;
    if (!children || children.length === 0) {
      return;
    }
    var selectedIndex = children.findIndex(function (item) {
      return !!item.props.checked || !!item.props.selected || !!item.props.expanded;
    });
    if (selectedIndex === -1) {
      return;
    }
    if (useVirtual) {
      var instance = this.virtualEl.getInstance();
      setTimeout(function () {
        return instance.scrollTo(selectedIndex);
      }, 0);
    } else {
      var itemSelector = "." + prefix + "menu-item";
      var menu = findDOMNode(this.menuEl);
      var targetItem = menu.querySelectorAll(itemSelector)[selectedIndex];
      if (targetItem) {
        menu.scrollTop = targetItem.offsetTop - Math.floor((menu.clientHeight / targetItem.clientHeight - 1) / 2) * targetItem.clientHeight;
      }
    }
  };
  _proto.renderMenu = function renderMenu(items, ref, props) {
    var _this2 = this;
    return /*#__PURE__*/React.createElement(Menu, _extends({
      ref: ref,
      role: "listbox"
    }, props), items.map(function (node) {
      if ( /*#__PURE__*/React.isValidElement(node) && node.type.menuChildType === 'item') {
        return /*#__PURE__*/React.cloneElement(node, {
          menu: _this2
        });
      }
      return node;
    }));
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      prefix = _this$props2.prefix,
      useVirtual = _this$props2.useVirtual,
      className = _this$props2.className,
      style = _this$props2.style,
      children = _this$props2.children,
      others = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    var menuProps = _extends({
      labelToggleChecked: false,
      className: prefix + "cascader-menu"
    }, others);
    return /*#__PURE__*/React.createElement("div", {
      ref: this.saveMenuRef,
      className: prefix + "cascader-menu-wrapper " + (className ? className : ''),
      style: style
    }, this.renderMenu(children, undefined, menuProps));
  };
  return CascaderMenu;
}(Component);
CascaderMenu.propTypes = {
  prefix: PropTypes.string,
  className: PropTypes.string,
  useVirtual: PropTypes.bool,
  children: PropTypes.node
};
export { CascaderMenu as default };